import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../_services/admin.service';
import { HeaderData } from 'src/app/_models/header-data';
import { BehaviorSubject } from 'rxjs';
import { RESULTS_NOT_FOUND } from 'src/app/_common/product-config';
import { PageCriteria } from 'src/app/_models/page-criteria';
import { Router } from '@angular/router';
import { CompanyStatusID, StatusCode } from 'src/app/_common/_enum/module.enum';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.scss']
})
export class CompanyListComponent implements OnInit {

  resultsNotFound = RESULTS_NOT_FOUND;
  private hasCompanies: boolean = true;
  private _total$ = new BehaviorSubject<number>(0);
  private loading: boolean = false;
  private loadingConfig:boolean = false;
  private headerData:HeaderData;
  private companies = [];
  private criteria: PageCriteria;
  private typeFilterObj: Object[];
  private statusFilterObj: Object[];

  private selectedStatus = null;
  private selectedType = null;
  private hasAccess:boolean = false;

  //private killServicesOnDestroy = [];

  constructor(private router: Router, private adminService: AdminService) { }

  ngOnInit() {
    this.criteria = new PageCriteria();
    this.getCompanyConfig();
    this.statusFilterObj = [
      {filterIndex: 5, displayName : 'All', value: null, group: 'CompanyStatus'},
      {filterIndex: 6, displayName : 'Active', value: '1', group: 'CompanyStatus'},
      {filterIndex: 7, displayName : 'Deactivated', value: '2', group: 'CompanyStatus'}
    ];
    this.selectedStatus = this.statusFilterObj.find((obj:any) => {return obj.group == 'CompanyStatus' && obj.displayName == 'Active'});

    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */
    
    //this.resetCriteria();
    //this.fetchCompanies();
    this.filterCompanies(this.statusFilterObj[1], "CompanyStatus");
  }

  get CompanyStatusIDEnum(){
    return CompanyStatusID;
  }

  setHeaderData(){
    this.headerData.pageTitle = "Companies";//.toLowerCase();
    this.headerData.breadcrumb = [{itemName: "ADMIN", itemLink: "/admin"}];

    this.adminService.header = this.headerData;
  }
  getCompanyConfig(){
    this.loadingConfig = true;
    let companyConfigSubscription = this.adminService.getCompanyConfig().subscribe(response => {
      this.loadingConfig = false;
      this.typeFilterObj = [{displayName: "All", value: null, group: "CompanyType"}];
      response.companyTypes.forEach(t => {
        this.typeFilterObj.push({displayName: t.typeDesc, value: t.typeID, group: "CompanyType"});
      });
      this.selectedType = this.typeFilterObj[0];
    });
    this.adminService.runningServices.push(companyConfigSubscription);
  }

  filterCompanies(item = null, type = null){
    if(type == 'CompanyType'){
      this.selectedType = item;
    }else if(type == 'CompanyStatus'){
      this.selectedStatus = item;
    }
    this.criteria.filterBy = [];
    if(this.selectedType && this.selectedType.value != null){
      this.criteria.filterBy.push({
        "FilterColumnName": "Type",
        "FilterValue": this.selectedType.value
      });
    }
    if(this.selectedStatus && this.selectedStatus.value != null){
      this.criteria.filterBy.push({
        "FilterColumnName": "StatusID",
        "FilterValue": this.selectedStatus.value
      });
    }

    this.criteria.pageNo = 1;
    this.fetchCompanies();
  }


  fetchCompanies(){
    this.loading = true;
    this.hasCompanies = true;
    let policiesByAccountSubscription = this.adminService.fetchCompanies(this.criteria).subscribe((companies:any) => {
      this.hasAccess = true;
      this.loading = false;
      this._total$.next(companies.length);
      this.companies = companies;
      this.hasCompanies = companies.length>0;
      console.log(this._total$);
    },error=>{
      this.loading = false;
      this.hasCompanies = false;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });

    this.adminService.runningServices.push(policiesByAccountSubscription);
  }

  goToCreateCompany(){
    this.router.navigateByUrl("admin/company/new");
  }

  get total$() { return this._total$.asObservable(); }

  onPageChange(){
    window.scrollTo(0, 0);
  }
  
  resetCriteria(){
    this.criteria.filterBy = [{}];
    this.criteria.pageNo = 1;
    this.criteria.sortBy = "Name";
    this.criteria.sortOrder = "asc";
  }
  ngOnDestroy() {
    this.adminService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
  
}
